module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cmslist"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('div', {
    staticClass: "left_and_right_container"
  }, [_c('div', {
    staticClass: "container_left"
  }, _vm._l((_vm.newsListData2.slice(
    (_vm.currentPage - 1) * _vm.pageSize,
    _vm.currentPage * _vm.pageSize
  )), function(item, index) {
    return _c('news-list-item', {
      key: index,
      attrs: {
        "NewsItemData": item
      },
      nativeOn: {
        "click": function($event) {
          return _vm.itemClickFun(item)
        }
      }
    })
  }), 1), _vm._v(" "), _c('RightNav', {
    attrs: {
      "list": _vm.list
    }
  })], 1), _vm._v(" "), (false) ? _c('el-pagination', {
    staticStyle: {
      "margin-left": "250px"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.newsListData2.length
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60305c24","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/CmsList.vue
// module id = 1502
// module chunks = 0